import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FormField from '../FormField';
import TenantClientsControl from '../TenantClientsControl';

class TenantsClientsField extends Component {
  mapValue(option) {
    return {
      value: option.id,
      label: option.name
    };
  }

  mapMultipleValues(options) {
    return options && options.length > 0 ? options.map(this.mapValue) : [];
  }

  getValue() {
    const { input: { value } } = this.props;
    return value && this.mapMultipleValues(value);
  }

  getOptions() {
    const { options } = this.props;
    return options && this.mapMultipleValues(options);
  }

  render() {
    const {
      input,
      name,
      changeFieldValue,
      options,
      autoFocus,
      disabled
    } = this.props;

    return (
      <FormField field={this.props}>
        <input {...input} type="hidden" />
        <TenantClientsControl
          name={name}
          fieldName={name}
          fieldValue={this.getValue()}
          options={this.getOptions()}
          changeFieldValue={changeFieldValue}
          autoFocus={autoFocus}
          disabled={disabled}
        />
      </FormField>
    );
  }
}

TenantsClientsField.propTypes = {
  changeFieldValue: PropTypes.func.isRequired,
  input: PropTypes.object,
  options: PropTypes.array,
  name: PropTypes.string,
  autoFocus: PropTypes.bool,
  disabled: PropTypes.bool
};

TenantsClientsField.defaulProps = {
  input: {}
};

export default TenantsClientsField;
